export default __webpack_public_path__ + "static/media/user.8300c51b.svg";